import { render, staticRenderFns } from "./rect.vue?vue&type=template&id=4d3e0740&scoped=true&"
import script from "./rect.vue?vue&type=script&lang=js&"
export * from "./rect.vue?vue&type=script&lang=js&"
import style0 from "./rect.vue?vue&type=style&index=0&id=4d3e0740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e0740",
  null
  
)

export default component.exports